export const toastBackgroundColors = {
  info: "bg-info-90",
  success: "bg-success-90",
  warning: "bg-warning-90",
  error: "bg-error-90",
};

export const toastForegroundColors = {
  info: "text-info-20",
  success: "text-success-20",
  warning: "text-warning-20",
  error: "text-error-20",
};
